import TextField from '@mui/material/TextField';
import styled from 'styled-components';
import { colors } from 'utils/colors';

export const TSelect = styled(TextField)`
  border: none !important;
  margin-right: 60px !important;

  select {
    margin-top: 8px;
    border: 1px solid ${colors.verde} !important;
    border-radius: 5px !important;
    padding: 5px 30px 5px 8px !important;
  }
`;
